import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import React from "react";
import { ProductsTableRegPriceColumnProps } from "./products-table-reg-price-column.props";
import { Price } from "./promo-table-reg-price-column.styles";
import { SideBySide } from "../../../../components/side-by-side/side-by-side.component";
import { ProductFieldStatus } from "../../features/product-status-indicator/types/product-field-status.type";
import { ProductsTableStatusIndicator } from "../../features/product-status-indicator/components/product-status-indicator/products-table-status-indicator.component";
import { formatMoney } from "../../../../utils/format-money.function";

export const ProductsTableRegPriceColumn = (props: ProductsTableRegPriceColumnProps) => {
  const getStatus = (): ProductFieldStatus =>
    props.wasPriceUpdated ? "system_overwritten" : "none";

  const formatPrice = (): string => formatMoney(props.price);

  return (
    <ResponsiveTableCell className="medium" align="left">
      <SideBySide>
        <Price>{formatPrice()}</Price>
        <ProductsTableStatusIndicator showIf={false} field="Price" status={getStatus()} />
      </SideBySide>
    </ResponsiveTableCell>
  );
};
